import Animated, { useAnimatedStyle, useSharedValue, withTiming } from "react-native-reanimated";
import { ScrollView, View, useWindowDimensions } from "react-native";
import { useRef, useState } from "react";

import Footer from "components/Footer";
import Header from "components/Header";
import NewsLetterCop from "components/NewsLetterCop";
import { hp } from "utils/normalizeV2";
import { useSegments } from "expo-router";

const ParentScrollView = ({ children, _scrollRef, gender }) => {
    const [headerHeight, setHeaderheight] = useState(100);

    const scrollPosition = useRef(0);
    const segments = useSegments();
    const { width, height } = useWindowDimensions();

    const closetAddMediaTranslateY = useSharedValue(0);

    const handleScroll = (event) => {
        const currentScrollPosition = event.nativeEvent.contentOffset.y;
        const offset = 5; // Define an offset threshold
        if (currentScrollPosition > scrollPosition.current + offset) {
            if (currentScrollPosition > headerHeight) {
                closetAddMediaTranslateY.value = withTiming(-200);
            }
        } else if (currentScrollPosition < scrollPosition.current - offset) {
            closetAddMediaTranslateY.value = withTiming(0); // Adjust the value as needed
        }
        scrollPosition.current = currentScrollPosition;
    };

    if (
        segments?.includes("privacy-policy") ||
        segments?.includes("privacy-policy-1") ||
        segments?.includes("terms-and-conditions")
    ) {
        const aspectRatio = width / height;
        if (!(aspectRatio > 1.3 && aspectRatio < 2.5 && height > 500 && width > 1000)) {
            return (
                <ScrollView ref={_scrollRef} onScroll={handleScroll} scrollEventThrottle={16}>
                    {children}
                </ScrollView>
            );
        }
    }

    const animatedStyle = useAnimatedStyle(() => {
        return {
            transform: [{ translateY: closetAddMediaTranslateY.value }],
        };
    });

    return (
        <>
            <Animated.View
                style={[
                    {
                        zIndex: 1,
                        position: "absolute",
                        width: "100%",
                    },
                    animatedStyle,
                ]}
                onLayout={(event) => {
                    const { x, y, width, height } = event.nativeEvent.layout;
                    setHeaderheight(height);
                }}
            >
                <Header gender={gender} />
            </Animated.View>
            <ScrollView
                ref={_scrollRef}
                contentContainerStyle={{
                    marginTop: headerHeight,
                }}
                onScroll={handleScroll}
                scrollEventThrottle={5}
            >
                <View
                    style={{
                        flex: 1,
                        minHeight: hp(500),
                        // marginTop: hp(150),
                    }}
                >
                    {children}
                </View>
                <NewsLetterCop />
                <Footer />
            </ScrollView>
        </>
    );
};

export default ParentScrollView;
